<script setup lang="ts">
interface TurnstileChallengeProps {
    // Generated by the useInteractionOnlyTurnstile() instance that renders its widget into this node. A widget cannot
    // be shared, so the id is unique per instance and must not be reused.
    containerId: string;
}

// PROPS
const { containerId } = defineProps<TurnstileChallengeProps>();
</script>

<template>
    <div :id="containerId" />
</template>
